import { useLocalStorage } from '../../hooks/useLocalStorage';
import { useTranslation } from 'react-i18next';
import { ThemeProvider } from '@mui/material';
import { useConfig } from '../../hooks/useConfig';
import { PropsWithChildren, useEffect } from 'react';
import { useLoading } from '../../context/LoadingContext';

const PersonalizedTheme = ({ children }: PropsWithChildren) => {
  const config = useConfig(true);
  const status = config.status();
  const { setLoading } = useLoading();

  const [_, setLanguageStore] = useLocalStorage<string>('language', 'es');
  const { i18n } = useTranslation();

  useEffect(() => {
    const validLanguages = ['es', 'en', 'pt'];
    const lang = validLanguages.includes(config.language)
      ? config.language
      : 'es';
    setLanguageStore(lang);
    i18n.changeLanguage(lang);
  }, [config.language]);

  // Control global loader based on config status
  useEffect(() => {
    if (status === 'ready') {
      setLoading(false, 'PersonalizedTheme');
    } else {
      setLoading(true, 'PersonalizedTheme');
    }
  }, [status, setLoading]);

  return status === 'ready' ? (
    <ThemeProvider theme={config.theme}>{children}</ThemeProvider>
  ) : null;
};

export default PersonalizedTheme;
